import { erpApi } from "@/shared/axios/erp-api";
import { urlBackend } from "@/shared/constants";
import type { FotosTrasladoSnapshot } from "../tables/fotos/traslado/fotos-traslado.actions";

const { post } = erpApi();

export type ObservacionesTecnicoRes = {
  /** Observaciones completas del agendamiento tras guardar. */
  observaciones: Record<string, any>;
  claves: string[];
  ignoradas: string[];
  /** Estado en vivo de la OT (el mismo del sondeo de fotos/excedente). */
  snapshot: FotosTrasladoSnapshot;
};

/**
 * Guarda, desde la OT del técnico (traslado o visita), las claves de
 * `agendamiento.observaciones` que le pertenecen: otros conceptos, puntos de
 * red, reinstalación AC y tipo de instalación (con sus historiales).
 *
 * Reemplaza al PUT genérico de agendamiento, que exigía `api.change_agendamiento`
 * (el técnico no lo tiene → 403 "faltan permisos"). Este endpoint solo pide
 * `api.change_ordentrabajo`. Enviar ÚNICAMENTE las claves cambiadas: el backend
 * conserva el resto (aprobaciones de Activaciones, excedente de fibra, etc.).
 */
export async function guardarObservacionesTecnico(
  idOrdenTrabajo: string,
  observaciones: Record<string, any>,
): Promise<ObservacionesTecnicoRes> {
  const res = await post<ObservacionesTecnicoRes>(
    `${urlBackend}api/v1/orden-trabajo/${idOrdenTrabajo}/observaciones-tecnico/`,
    { observaciones },
    true,
  );
  return res.data;
}
